// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-box {
  border: 3px solid var(--dynamic-color, #ccc);
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
  cursor: pointer;
  background-color: #fff;
}

.card-box:hover {
  transform: scale(0.96);
  color: #1a1a1a;
  border: 3px solid var(--dynamic-color);
}

.card-title-wrapper {
  padding: 10px 15px;
  background-color: var(--dynamic-color, #007bff);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  min-height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-title {
  margin: 0;
  font-weight: 200;
  font-size: 18px;
  color: white;
  text-align: center;
}

.card-separator {
  height: 2px;
  background-color: #ffffff;
  margin: 0 15px 10px;
  border-radius: 2px;
}

.inner {
  padding: 0 10px;
}

.highlightText {
  color: #36f;
}

.headerData {
  margin-top: -1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/common-components/card-component/card-component.component.scss"],"names":[],"mappings":"AAAA;EACE,4CAAA;EACA,mBAAA;EACA,yCAAA;EACA,+BAAA;EACA,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,sBAAA;EACA,cAAA;EACA,sCAAA;AACF;;AAEA;EACE,kBAAA;EACA,+CAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":[".card-box {\n  border: 3px solid var(--dynamic-color, #ccc);\n  border-radius: 10px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease;\n  cursor: pointer;\n  background-color: #fff;\n}\n\n.card-box:hover {\n  transform: scale(0.96);\n  color: #1a1a1a;\n  border: 3px solid var(--dynamic-color);\n}\n\n.card-title-wrapper {\n  padding: 10px 15px;\n  background-color: var(--dynamic-color, #007bff);\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n  min-height: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.card-title {\n  margin: 0;\n  font-weight: 200;\n  font-size: 18px;\n  color: white;\n  text-align: center;\n}\n\n.card-separator {\n  height: 2px;\n  background-color: #ffffff;\n  margin: 0 15px 10px;\n  border-radius: 2px;\n}\n\n.inner {\n  padding: 0 10px;\n}\n\n.highlightText {\n  color: #36f;\n}\n\n.headerData {\n  margin-top: -1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
